/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

// Utilities
import Button from '../buttons/primary'
// Images
import hero_img from '../../images/illustrations/home.svg'

const Home = () => {
    return (
        <div className="hero pt-24 pb-28 max-w-7xl mx-auto px-5 sm:px-5 lg:px-5">
            <div className="grid grid-cols-2 items-center">
                <div className="content col-span-2 sm:col-span-2 md:col-span-1 lg:col-span-1">
                    <h1 className="text-gray-100 font-bold text-5xl leading-tight mb-3">Supercharge your hosting experience.</h1>
                    <p className="text-gray-300 mb-8">Choose from a wide array of datacenters around the globe.</p>
                    <div className="features mb-12">
                        <div className="flex items-center mb-2.5">
                            <div className="flex items-center w-52">
                                <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </span>
                                <p className="text-gray-300 text-base ml-4">Premium Support</p>
                            </div>
                            <div className="ml-2 flex items-center">
                                <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </span>
                                <p className="text-gray-300 text-base ml-4">Full Customization</p>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="flex items-center w-52">
                                <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </span>
                                <p className="text-gray-300 text-base ml-4">Full Control</p>
                            </div>
                            <div className="ml-2 flex items-center">
                                <span className="bg-icon text-purple-500 p-0.5 border border-purple-500 rounded-full">
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </span>
                                <p className="text-gray-300 text-base ml-4">Affordable</p>
                            </div>
                        </div>
                    </div>
                    <div className="buttons">
                        <div className="flex mb-8 sm:mb-8 md:mb-0 lg:mb-0">
                            <Button route={true} link='/games/minecraft' rounded='sm' arrow={true} length='sm'>Get Started</Button>
                        </div>
                    </div>
                </div>
                <div className="illustration hidden sm:hidden md:block lg:block">
                    <img src={hero_img} className="ml-auto" style={{width: '30rem'}} alt='Illustration' />
                </div>
            </div>
        </div>
    )
}

export default Home